import hexToRgb from "@/core/helpers/hexToRgb";

export const getRowGradient = (hex: string): string => {
  const [r, g, b] = hexToRgb(hex);
  return `linear-gradient(269deg,
  rgba(${r}, ${g}, ${b}, 0.13) 10%,
  rgba(${r}, ${g}, ${b}, 0.01) 50%,
  rgba(${r}, ${g}, ${b}, 0.00) 100%
)`;
};
